import {NavigationItem} from "@/lib/interfaces/navigation";
import NavFullItem from "@/components/header/NavFullItem";

type NavMainProps = {
    items: NavigationItem[]
}

export default function NavFull(props: NavMainProps) {
    return (
        <nav className="navFull-items">
            {props.items.map(item => (
                <NavFullItem key={item.id} item={item} />
            ))}
        </nav>
    )
}